<template>
  <div>
    <b-sidebar
      class="desktop-none"
      :visible="visibleSidebarMobile"
      right
      no-close-on-esc
      :backdrop="true"
      :shadow="false"
      bg-variant="white"
      sidebar-class="mobile-sidebar"
      header-class="d-block p-0"
      body-class="mobile-sidebar__body"
      footer-class="d-block p-0 h-auto"
      :width="width"
      @hidden="close"
    >
      <template #header>
        <LogoBox />
        <ParvandehBox @close="close" />
        <AudioRepositoryBox />
      </template>
      <MenuList />
      <template #footer>
        <ProfileBox />
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import LogoBox from "../../logo-box/LogoBox.vue";
import ParvandehBox from "../../parvandeh-box/ParvandehBox.vue";
import ProfileBox from "../../profile-box/ProfileBox.vue";
import MenuList from "../../menu-list/MenuList.vue";
import { mapGetters } from "vuex";
import { storeDispatcher } from "@/shared/utils";
import { AudioRepositoryBox } from "../..";

export default {
  components: {
    LogoBox,
    ParvandehBox,
    ProfileBox,
    MenuList,
    AudioRepositoryBox,
  },
  data() {
    return {
      width: "250px",
    };
  },
  computed: {
    ...mapGetters(["visibleSidebarMobile"]),
  },
  methods: {
    storeDispatcher,
    async close() {
      await storeDispatcher("visibleSidebarMobile", false);
    },
  },
};
</script>
